import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@material-ui/core/TablePagination'; 
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import pageimg from './images/attendance.png';
import GolfCourseIcon from '@mui/icons-material/GolfCourse';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,DatePicker, 
  KeyboardDatePicker,
  DateTimePicker
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { addDays } from "date-fns";
 import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import dayjs from 'dayjs';
import Moment from 'react-moment';
import moment from 'moment';
import calenderimg from './images/calender-icon.png';

import Grid from '@material-ui/core/Grid';
import ReactToPrint from 'react-to-print';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const headCells = [
   
  { id: 'ur_name', numeric: false,  label: 'Name' },
   { id: 'ult_latitude', numeric: false,  label: 'Check-in Address' },
{ id: 'ult_longitude', numeric: false,  label: 'Check-out Address' },
{ id: 'ult_checkinadress', numeric: false,  label: 'Check-in Date' },
{ id: 'ult_checkoutaddress', numeric: false,  label: 'Check-out Date' },


  ]

  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};




const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});



export default class UserLocationTrackingReport extends Component {
	
    constructor(props) {
    super(props);
		
	var date = addDays(moment().toDate(),0);
		 var month="",date1="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
	 
	 
	  if((date.getDate() )<10)
	 {
		date1="0"+ (date.getDate() )		 
	 }else{date1=(date.getDate())}
      this.state = {redirect: false,
      userlocdata:[],
	  page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],order:'desc' ,orderBy:'',
	   ult_id:'', fromdate:addDays(moment().toDate(),0),fromdate1:date.getFullYear() + '-' + month + '-' +date1,
	   todate1:date.getFullYear() + '-' + month + '-' +date1,todate:addDays(moment().toDate(),0),
	

      }
       this.updateDonenewParent = this.updateDonenewParent;
	 this.componentRef = React.createRef();  
	   
	}
	

	
	
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,
	  userlocdata:[],
    });
	 this.apicall(this.state.page, this.state.rowsPerPage);
//this.componentDidMount();  
}
	





	componentWillMount() {
	
	
	document.title = "MM Coching Center - User CICO Report";
	
	if(localStorage.getItem("MMCuserid")==null)

		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
	
	
	
	
	  localStorage.setItem("page",this.state.rowsPerPage)

  this.apicall(this.state.page,this.state.rowsPerPage);
 
  
  
} 


handleClickSearch=()=>{   

  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 


myChangeHandler = (event) => {
  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
  this.setState({
        [nam]: val
    });
 
}




  
apicall(page,rowsPerPage){
	
	
				
	 axios.get(Serverurl+'ajaxuserlocationtracking.php?action=userlocationtrack&ult_id='+this.state.ult_id+'&ult_checkindate='+this.state.fromdate1+'&ult_checkoutdate='+this.state.todate1+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  userlocdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
			let copy=[50, 100, 150, 200, 250];
			
	  
	  this.setState({rowsPaging:copy});
	 
     }
	 else{
		   this.setState({userlocdata:[],totaldata:0});
	 }
 
    });
}

handtoChange=(date)=> {
	 
	
	 var month="";
 var date1 = new Date(date);
 

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ todate:dayjs(date),
todate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
	
  }  
 
    handfrChange = (date) => {
	
	 var month="";
 var date1 = new Date(date);




	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ fromdate:dayjs(date),
fromdate1:date1.getFullYear() + '-' + month + '-' +date1.getDate(),
//todate1:date1.getFullYear() + '-' + month + '-' +date1.getDate(),
	 })
	
  }
  


handleChangePage = (event, newPage) => {  
   
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  };  
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
    localStorage.setItem("page",pageval)

    setTimeout(() =>  this.componentDidUpdate() ,500);
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};




render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  

  <React.Fragment>
   
<div className="containermain">
<div className="boxheading">
				  <div className="contntpad">
<h2><img src={pageimg}/>User Check - IN/ OUT Report</h2>
</div></div>

   <div className="searchmaster">


  
 
  <ul>
  <li>
    <p>From Date <span className="validationtxt"></span></p>
    <p>
	<MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justify="space-around">
	 


  <DatePicker fullWidth
        value={this.state.fromdate || addDays(moment().toDate(),1)}
        onChange={this.handfrChange}
		maxDate={addDays(moment().toDate(),0)}
            format="dd/MM/yyyy"
        autoOk name="fromdate"
        ampm={false} inputVariant="outlined"
      />

 </Grid>
    </MuiPickersUtilsProvider>
	
      
      
    </p>
  </li>

  <li>
    <p>To Date <span className="validationtxt"></span></p>
    <p>
	<MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justify="space-around">
	 


  <DatePicker fullWidth
        value={this.state.todate || addDays(moment().toDate(),1)}
        onChange={this.handtoChange}
		maxDate={addDays(moment().toDate(),0)}
            format="dd/MM/yyyy"
        autoOk name="todate"
        ampm={false} inputVariant="outlined"
      />

 </Grid>
    </MuiPickersUtilsProvider>
	
	
      
    </p>
  </li>
</ul>



		
		<div className="searchnewbtn">
		<p className="searchbutton">
		<Button variant="contained" disabled={this.state.btndisabled} onClick={this.handleClickSearch} className={useStyles.submit} endIcon={<SearchIcon />}>
			Search
      </Button>&nbsp;&nbsp;<ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="exportbtn"
                    table="usercicoreport"
                    filename="User CICO Report"
                    sheet="User CICO Report"
                    buttonText="Export"/>&nbsp;&nbsp;<ReactToPrint 
            trigger={() => <p id="print-button" className="exportbtns">Print </p>}
			content={() =>  this.componentRef} /></p>
		</div>	
		
		
		
		
		
</div>		



<div ref={el => (this.componentRef = el)}>
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table id="usercicoreport" stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.userlocdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.userlocdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.ur_name}</TableCell>
<TableCell>{item.ult_checkinadress}</TableCell>
<TableCell>{item.ult_checkoutaddress}</TableCell>
<TableCell>{item.checkindate}</TableCell>
<TableCell>{item.checkoutdate}</TableCell>

 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colSpan="5">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[50, 100, 150, 200, 250]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />   
  </Paper>
    
</div></div>
 </React.Fragment> 

 
 
  );
}
}


